export const BROCHURES_LIST_PATH = "pages/brochures-list";